/**
 * A filter of two to five choices, as pressed buttons in one group. A count never sits inside it:
 * the list below is the count (design.md section 3, rule 1).
 */
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange,
  testId
}: {
  label: string;
  value: T;
  options: ReadonlyArray<{ value: T; label: string }>;
  onChange: (next: T) => void;
  testId?: string;
}) {
  return (
    <div className="segmented" role="group" aria-label={label} data-testid={testId}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          aria-pressed={option.value === value}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
